import { render, staticRenderFns } from "./NoBackgroundImage.vue?vue&type=template&id=158ef71e"
import script from "./NoBackgroundImage.vue?vue&type=script&lang=js"
export * from "./NoBackgroundImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports